import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { InvoiceFormTypes } from "models/formTypes";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import ActivateInvoiceForm from "./activateForm";
import { useInvoiceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";
import { UtilsHelper } from "utils/helpers";

const ActivateInvoiceFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const invoiceService = useInvoiceService();

  const validationSchema = Yup.object<InvoiceFormTypes.ActivateInvoices>({
    hasSentInvoiceBefore: Yup.boolean().required(TranslationKeys.Validations.Required),
    hasEUCustomers: Yup.boolean().required(TranslationKeys.Validations.Required),
    hasRegisteredForFTax: Yup.boolean().required(TranslationKeys.Validations.Required),
    lastInvoiceNumber: Yup.number().when(
      [FormFieldConstants.Invoice.ActivateInvoices.HasSentInvoiceBefore],
      ([hasSentInvoicesBefore], schema: Yup.NumberSchema) =>
        hasSentInvoicesBefore
          ? schema.required(TranslationKeys.Validations.Required).moreThan(0, TranslationKeys.Validations.Invalid)
          : schema
    ),
    preferedStartInvoiceNumber: Yup.number().when(
      [FormFieldConstants.Invoice.ActivateInvoices.HasSentInvoiceBefore],
      ([hasSentInvoicesBefore], schema: Yup.NumberSchema) =>
        hasSentInvoicesBefore ? schema : schema.moreThan(0, TranslationKeys.Validations.Invalid)
    ),
  });

  const defaultValues: InvoiceFormTypes.ActivateInvoices = {
    preferedStartInvoiceNumber: 1,
  };

  const handleSubmit = (values: InvoiceFormTypes.ActivateInvoices) => {
    return invoiceService.activateInvoices({
      hasSentInvoiceBefore: values.hasSentInvoiceBefore ?? false,
      lastInvoiceNumber: values.hasSentInvoiceBefore ? values.lastInvoiceNumber : undefined,
      preferedStartInvoiceNumber: values.hasSentInvoiceBefore
        ? undefined
        : !UtilsHelper.isEmpty(values.preferedStartInvoiceNumber)
        ? values.preferedStartInvoiceNumber
        : 1,
      hasEUCustomers: values.hasEUCustomers ?? false,
      hasRegisteredForFTax: values.hasRegisteredForFTax ?? false,
    });
  };

  return (
    <ActivateInvoiceForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(ActivateInvoiceFormContainer);
